import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  CardWrapper,
  SelectionCard,
  Wrapper,
  ScrollableContent,
  ActionSection,
  RupeeIcon,
  MobileIcon,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import * as Yup from "yup";
import { staff_roles } from "../../Config";
import SelectOptionModal from "../SelectOptionModal"; // Adjust path as needed

const EditStaff = ({
  editStaffLoading,
  editStaffMutate,
  setIsEditStaff,
  selectedData,
  setIsDeactivateStaff,
}) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight); // updates when Safari UI changes
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const initialValues = {
    fullName: selectedData?.name,
    mobile: selectedData?.mobile,
    role: selectedData?.role,
    gender: selectedData?.gender,
    salary: selectedData?.salary,
    status: selectedData?.status,
    // role: selectedData?.role,
  };

  const gender = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
  ];

  // Format staff_roles for SelectOptionModal
  const staffRoleOptions = staff_roles.map((role) => ({
    label: role.label,
    value: role.value,
  }));

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Inactive" },
  ];
  const handleSubmit = (values, { resetForm }) => {
    const nameRegex = /^[A-Za-z0-9. ]{4,}$/;
    const mobileRegex = /^\d{10}$/;
    const salaryRegex = /^\d{1,7}$/;
    const maxSalaryDeposit = 1000000;

    if (!nameRegex.test(values.fullName)) {
      toast.error("Only letters, numbers, spaces and dot are allowed.");
      return;
    }

    if (!mobileRegex.test(values.mobile)) {
      toast.error(
        "Mobile number should be exactly 10 digits long and contain only numbers",
      );
      return;
    }

    if (!values.gender) {
      toast.error("Gender is required");
      return;
    }
    if (
      (values.salary && !salaryRegex.test(values.salary)) ||
      parseInt(values.salary) > maxSalaryDeposit
    ) {
      toast.error(
        "Salary must be less than 10,00,000 and contain only numbers",
      );
      return;
    }

    editStaffMutate({
      name: values.fullName,
      mobile: values.mobile,
      gender: values.gender,
      salary: Number(values.salary),
      role: values.role || "",
      id: selectedData?.id,
      status: values?.status,
    });
    // resetForm();
  };

  const validationSchema = Yup.object({
    fullName: Yup.string()
      .required("Name is required")
      .matches(
        /^[A-Za-z0-9.\s]+$/,
        "Only letters, numbers, spaces and dot are allowed.",
      )
      .min(4, "Name must be at least 4 characters long"),
    // role: Yup.number().required("Staff Role is required"),
  });

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Header>
        <h1 className="text-white text-lg font-medium">Edit Staff</h1>
        <button onClick={() => setIsEditStaff(false)}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, resetForm, errors, touched }) => {
            const handleRoleSelect = (selectedValue) => {
              setFieldValue("role", selectedValue);
            };
            const getSelectedStaffRole = () => {
              if (!values.role) return "Select Staff Role";

              const selected = staffRoleOptions.find(
                (s) => s.value === values.role,
              );

              return selected ? selected.label : "Select Staff Role";
            };

            return (
              <Form>
                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                  <Wrapper>
                    {/* <div
                      className={`mb-5 rounded-2xl border px-4 py-3 flex items-center justify-between shadow-sm ${
                        selectedData?.status === 1
                          ? "bg-emerald-50 border-emerald-200"
                          : "bg-red-50 border-red-200"
                      }`}
                    >
                      <div>
                        <p
                          className={`text-sm font-semibold ${
                            selectedData?.status === 1
                              ? "text-emerald-700"
                              : "text-red-700"
                          }`}
                        >
                          {selectedData?.status === 1
                            ? "Staff is Active"
                            : "Staff is Inactive"}
                        </p>

                        <p className="text-xs text-gray-500 mt-1">
                          {selectedData?.status === 1
                            ? "This staff member currently has access to the system."
                            : "This staff member does not currently have access."}
                        </p>
                      </div>

                      <button
                        type="button"
                        onClick={() => {
                          setIsEditStaff(false);

                          setTimeout(() => {
                            setIsDeactivateStaff(true);
                          }, 100);
                        }}
                        className={`px-4 py-2 rounded-full text-xs font-semibold transition-all duration-200 ${
                          selectedData?.status === 1
                            ? "bg-red-100 text-red-600 hover:bg-red-500 hover:text-white"
                            : "bg-emerald-100 text-emerald-600 hover:bg-emerald-500 hover:text-white"
                        }`}
                      >
                        {selectedData?.status === 1 ? "Inactivate" : "Activate"}
                      </button>
                    </div> */}
                    <InputGroup>
                      <Label htmlFor="fullName">Name *</Label>
                      <FieldWrappers>
                        <Field
                          type="text"
                          name="fullName"
                          id="fullName"
                          autoComplete="off"
                          placeholder="Enter staff name"
                        />
                      </FieldWrappers>
                      {errors.fullName && touched.fullName && (
                        <ErrorText>{errors.fullName}</ErrorText>
                      )}
                    </InputGroup>
                    <InputGroup>
                      <Label htmlFor="mobile">Mobile *</Label>
                      <FieldWrappers className="bg-gray-100">
                        <MobileIcon />
                        <Field
                          type="text"
                          name="mobile"
                          id="mobile"
                          autoComplete="off"
                          maxLength={10}
                          placeholder="Enter 10-digit mobile number"
                          className="w-full pl-5"
                          required
                          readOnly
                        />
                      </FieldWrappers>
                    </InputGroup>

                    <InputGroup>
                      <Label>Gender *</Label>
                      <CardWrapper>
                        {gender.map((mode) => (
                          <SelectionCard
                            key={mode.value}
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setFieldValue("gender", mode.value, false);
                            }}
                            className={
                              values.gender === mode.value
                                ? "bg-[#26A69A] text-white"
                                : "bg-gray-100 text-gray-800"
                            }
                          >
                            <span className="text-sm">{mode.label}</span>
                          </SelectionCard>
                        ))}
                      </CardWrapper>
                    </InputGroup>

                    <InputGroup>
                      <Label htmlFor="salary">Monthly Salary </Label>
                      <FieldWrappers>
                        <RupeeIcon />
                        <Field
                          type="number"
                          name="salary"
                          id="salary"
                          autoComplete="off"
                          className="w-full pl-5"
                          placeholder="Enter mothly salary (optional)"
                        />
                      </FieldWrappers>
                    </InputGroup>
          
                    {/* <InputGroup>
                      <Label>Staff Access</Label>
                      <PayrollContainer>
                        <Label>Status</Label>

                        <div className="flex bg-gray-100 rounded-xl p-1 w-fit">
                          <button
                            type="button"
                            onClick={() => {
                              if (values.status !== 1) {
                                setIsEditStaff(false);

                                setTimeout(() => {
                                  setIsDeactivateStaff(true);
                                }, 100);
                              }
                            }}
                            className={`px-4 py-1.5 text-sm rounded-md transition-all ${
                              values.status === 1
                                ? "bg-white shadow text-green-600"
                                : "text-gray-500"
                            }`}
                          >
                            Activate
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              if (values.status !== 2) {
                                setIsEditStaff(false);

                                setTimeout(() => {
                                  setIsDeactivateStaff(true);
                                }, 100);
                              }
                            }}
                            className={`px-4 py-1.5 text-sm rounded-md transition-all ${
                              values.status === 2
                                ? "bg-white shadow text-red-600"
                                : "text-gray-500"
                            }`}
                          >
                            Inactivate
                          </button>
                        </div>
                      </PayrollContainer>
                    </InputGroup> */}
                  </Wrapper>
                </ScrollableContent>
                <ActionSection>
                  <SideCancelBtn
                    type="button"
                    onClick={() => setIsEditStaff(false)}
                  >
                    Cancel
                  </SideCancelBtn>
                  <SubmitBtn type="submit" disabled={editStaffLoading}>
                    {editStaffLoading ? "Updating..." : "Update"}
                  </SubmitBtn>
                </ActionSection>

                {/* Staff Role Selection Modal */}
                <SelectOptionModal
                  isOpen={isRoleModalOpen}
                  onClose={() => setIsRoleModalOpen(false)}
                  title="Select Staff Role"
                  options={staffRoleOptions}
                  selectedValue={values.role}
                  onSelect={handleRoleSelect}
                  searchPlaceholder="Search staff roles..."
                />
              </Form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const PayrollContainer = tw.div`
  flex items-center justify-between
  border border-gray-200
  rounded-lg
  px-4 h-12
  bg-white
`;

export default EditStaff;
